export default __webpack_public_path__ + "static/media/dashboard-tickets-in-process.0234b840.svg";